import { render, staticRenderFns } from "./DiagnosticoModalEdit.vue?vue&type=template&id=98bfcd5c"
import script from "./DiagnosticoModalEdit.vue?vue&type=script&lang=js"
export * from "./DiagnosticoModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports